import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchAdminPayouts = createAsyncThunk('adminPayouts/fetchAdminPayouts', async (_, thunkAPI) => {
  try {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    const response = await axios.get('/api/admin/payouts', {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.payouts;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const updatePayoutStatus = createAsyncThunk('adminPayouts/updatePayoutStatus', async ({ id, status }, thunkAPI) => {
  try {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    const response = await axios.put(`/api/admin/payouts/${id}/status`, { status }, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.payout;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
  }
});

const adminPayoutsSlice = createSlice({
  name: 'adminPayouts',
  initialState: { payouts: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminPayouts.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchAdminPayouts.fulfilled, (state, action) => { state.loading = false; state.payouts = action.payload; })
      .addCase(fetchAdminPayouts.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(updatePayoutStatus.fulfilled, (state, action) => {
        const index = state.payouts.findIndex(p => p._id === action.payload._id);
        if (index !== -1) {
          state.payouts[index] = action.payload;
        }
      });
  }
});

export default adminPayoutsSlice.reducer;
